import React from 'react'
import Container from './container.js'
import Navigation from './navigation.js'
import styles from '../components/base.css'

class Template extends React.Component {
  render() {
    const { children } = this.props
   
    return (
      <Container>
        <Navigation />
        {children}
      </Container>
    )
  }
}

export default Template
